var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEjIsotipoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245.87 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7d9e18;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill-rule:evenodd;}.cls-2{fill:#006b9e;}.cls-3{fill:#f39200;}.cls-4{fill:#0091cf;}.cls-5{fill:#d76f21;}.cls-6{fill:#bbcd00;}.cls-7{fill:#bccf00;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.19,88l2.42-4.81,18.84,36.19L205.8,109a71.92,71.92,0,0,0,3.75-6.26c-49.34-29.61-92.61-41.85-131.63-37.9,2-14.06,6.27-25.46,22.1-32.36C154.09,39.81,179.58,58.69,219.19,88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158,15C112-9,89.23,2.37,80.34,4.93,61.48,24,70.06,47.72,74.82,63.21c4.4-36.14,37-42,75.24-30.75h0a35.55,35.55,0,0,1-2,4.22l36.46,5.06L162,8.78,158,15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.6,187.05C182.6,294.63,13.86,273.59.78,143c18.88,103.6,170.8,111.89,233.82,44.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M245.87,150c-59.4,30.6-128-16.73-151.48-49.09C77,79.27,51.39,31,75.27,7.3-1.93,45.52,46.69,194.94,197.55,179.51h0c18.37-2.23,33.89-8.46,45-13.47A96.39,96.39,0,0,0,245.87,150Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.47,117.58c-16-6.6-49.18-21.73-82.44-25.72,0,3.15,22.7,27.76,31.65,33.42,14.92,1.94,24.56,4.64,42.92,10.27a16.41,16.41,0,0,1-2.21,5.27l35.1,2.78-23.15-31.2-1.87,5.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.31,133.58c-4.53,2.76-7.44,4.84-10.59,8.43A61.77,61.77,0,0,1,40.2,97.19c3.88,13,9.85,23.52,19.11,36.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.07,187.64C16.83,175.51,5.92,157.78.44,136.7c8,35.16,24,50.83,35.83,61.89A86.49,86.49,0,0,1,35.07,187.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1.07,99.59A104.51,104.51,0,0,1,6,80.18,138.55,138.55,0,0,0,1.07,99.59Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.6,37.16c-8.36,3.89-11.49,6.5-11.44,6.43-25.1,54.85,4.11,90.87,13.52,100.77,0,0-15.76-23.8-7.29-54.69-4.49-18.15-3.33-39.1,5.21-52.51Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M241.71,168.12a130.35,130.35,0,0,1-6,15.69c-86.25,53-167.7,34.12-214.64-13.77C.64,145.51-1.93,120,1,100c0-.15,0-.28.06-.42A138.55,138.55,0,0,1,6,80.18c0-.16.11-.31.17-.47,9-26.47,22.34-33.33,22.34-33.33C18.38,67.33,17.18,86,20.29,101.8a.11.11,0,0,0,0,.06C28.4,138.76,51,161,88.84,178,125,194.15,196,197,241.71,168.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEjIsotipoColor);
export default __webpack_public_path__ + "static/media/ej-isotipo-color.31ec7b29d8719adfccc04755a0f68aa2.svg";
export { ForwardRef as ReactComponent };